import { render, staticRenderFns } from "./MemberData.vue?vue&type=template&id=a9275182&scoped=true"
import script from "./MemberData.vue?vue&type=script&lang=js"
export * from "./MemberData.vue?vue&type=script&lang=js"
import style0 from "./MemberData.vue?vue&type=style&index=0&id=a9275182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9275182",
  null
  
)

export default component.exports